
import moment from 'moment';
import React from 'react';
import { Col, Form} from 'react-bootstrap';
import DatePicker from 'react-datepicker';

function QuestionTemplate({questionType,qualifications,t, buildJson, questionId,builJsonText,builJsonMultiple,note,isUpdate, buildJsonDate, setDoSave}) {
    
    const switchParams = (tipoPregunta,qualifications,note)=>{
        //console.log(qualifications)
        switch (tipoPregunta) {
            case 1:
                return (
                        <Form.Control 
                            as="textarea" 
                            disabled={isUpdate} 
                            rows={3} 
                            value={note} 
                            onChange={e=>builJsonText(e.target.value, questionId)}
                            onBlur={e=>setDoSave(true)}
                        />
                );
            case 8:
                return (
                        <Form.Control 
                            as="select" 
                            disabled={isUpdate} 
                            value={note} 
                            onChange={e=>builJsonText(e.target.value, questionId)}
                            onBlur={e=>setDoSave(true)}
                        >
                            <option value="">Seleccionar opción</option>
                            <option value="N/A">No aplica</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                        </Form.Control>
                );

            case 3:

                return (
                    <Form.Control 
                        as="select" 
                        disabled={isUpdate} 
                        onChange={e=>buildJson(e.target.value, questionId)}
                        value={qualifications.filter(e=>e.selected==="selected").length > 0 ? qualifications.filter(e=>e.selected==="selected")[0].id : ''} 
                        onBlur={e=>setDoSave(true)}                           
                    >
                        <option value="">Selecciona</option>
                        {
                            qualifications.map((quali,it)=>{
                                
                                return ( <option key={it} value={quali.id}>{quali.label}</option>);
                            })
                        }
                    </Form.Control>                    
                );
            case 2:
                return(
                    <Col >
                        {
                            qualifications.map((quali,it)=>{
                                return(
                                    <Form.Check 
                                        key={it}
                                        type="checkbox"
                                        label={quali.label}
                                        checked={quali.checked ? true : false}
                                        value=''
                                        onChange={e=>{
                                            builJsonMultiple(e.target.checked, quali.id, questionId)
                                            setDoSave(true)
                                        }}
                                    />
                                );
                            })
                        }
                    </Col>
                );
            case 7:
                return (
                    <DatePicker
                        selected={note ? moment(note, "DD/MM/YYYY").toDate() : null} 
                        onChange={(date) => buildJsonDate(date, questionId)}
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        maxDate={new Date()}
                    />
                    // <Form.Control as="textarea" disabled={isUpdate} rows={3} value={note} onChange={e=>builJsonText(e.target.value, questionId)}/>
                );
            default:
                return(
                    null
                );
        }
    }
    return(
        switchParams(questionType?.tipoPregunta.id,qualifications,note)
    );
}

export default QuestionTemplate